import React, { useEffect, useState } from "react";
import "./Login.scss";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "../../../utils/axios";
import { useGoogleLogin } from "@react-oauth/google";
import { setSession, setUser } from "../auth-helper";

import LanguagePicker from "../../../LanguagePicker";
import BaseDialog from "../../../modelDialogs/BaseDialog";
import Logger from "../../../Logger";
import GlobalWaitIndicator from "../../GlobalWaitIndicator";
import { itx, noItx } from "../../../translationItx/itx";
import { authRedirectTarget, type AuthLocationState } from "../auth-redirect";

var CryptoJS = require("crypto-js");

const logger = new Logger();

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const redirectTarget = authRedirectTarget(location.state as AuthLocationState | null);

  useEffect(() => {
    state._navigate = navigate;
  }, []);
  const [seePasword, setSeePassword] = useState(false);
  const queryParameters = new URLSearchParams(window.location.search);
  const emailDefault = queryParameters.get("email") || "";

  const loginSchema = Yup.object().shape({
    password: Yup.string().required(state.translate("loginPage.enterPassword", "Please enter Password!")),
    email: Yup.string()
      .email(state.translate("register.emailInvalid", "Invalid email"))
      .required(state.translate("register.emailrequired", "Email is Required!")),
  });
  /**
   * Login Submit
   * @param values
   * @param setSubmitting
   */
  const handleSubmit = (values: any, { setSubmitting }: any) => {
    try {
      // aboAvailiable("email", { values: values, obj: { setSubmitting } }, () => {
      verifySubmit(values, { setSubmitting });
      //});
    } catch (ex) {
      logger.error(ex);
    }
    setSubmitting(false);
  };

  function verifySubmit(values: any, { setSubmitting }: any) {
    try {
      let payload = {
        ...values,
        password: encrypt(values.password),
      };
      axios
        .post("/api/login", payload)
        .then(async (result: any) => {
          if (result.data.DATA?.token) {
            // redirect to APP Dashboard
            result.data.DATA.password = encrypt(values.password);
            const profile_pic = await getUserProfilePic(result.data.DATA.id);
            let pfp = profile_pic?.data;
            let starred = result.data.DATA?.favourited_projects;
            if (pfp) {
              localStorage.setItem(`profilePicture${result.data.DATA.id || ""}`, pfp);
            }
            if (starred) {
              localStorage.setItem("favoriteSelectedProjects", starred);
            }
            signIn(result.data.DATA);
          }
        })
        .catch((e) => {
          let errmsg = e;

          let title = state.translate("error", "Error");
          let text = state.translate("setPassword.somthingWentwrong", "Something went wrong. Please try again.");

          if (!navigator.onLine) {
            text = state.translate(
              "loginPage.connectionInternetNotAailiable",
              "Die Verbindung zum Server kann nicht hergestellt werden. Bitte überprüfen Sie Ihr Internet.",
            );
          }

          if (errmsg?.message) {
            if (errmsg.message == "User Not found.") {
              title = state.translate("loginPage.userNotFound", "User Not Found");
              text = state.translate("loginPage.checkUserNameAndEmail", "Check if Email is correct");
            }
          } else if (errmsg?.DATA && errmsg?.MESSAGE) {
            title = errmsg.MESSAGE;
            if (errmsg.DATA == "Email is not verified. Please check your inbox and verify your email.") {
              text = state.translate("loginPage.emailNotVerified", "Email not verified");
            } else if (errmsg.DATA == "Invalid Password!") {
              text = state.translate("loginPage.invalidPassword", "Invalid Password!");
            }
          } else {
            title = state.translate("error", "Error");
            text = state.translate("setPassword.somthingWentwrong", "Something went wrong. Please try again.");
          }

          state.dialogManager.openDialog(
            <BaseDialog
              className="dialog-standard"
              title={title}
              onOk={() => {
                return true;
              }}
              okCaption={state.translate("ok", "Ok")}
              noAbortButton={true}
            >
              <div
                style={{
                  padding: "20px",
                  maxWidth: "600px",
                  textAlign: "center",
                }}
              >
                {text}
              </div>
            </BaseDialog>,
          );
        });
    } catch (ex) {
      logger.error(ex);
    }
    setSubmitting(false);
  }

  /**
   * Google Sign In
   */
  const googleSignIn = useGoogleLogin({
    onSuccess: (tokenResponse) =>
      // aboAvailiable("google", tokenResponse.access_token, () => {
      {
        verifyGoogleUser(tokenResponse.access_token);
      },
    // }),
    // onSuccess: (tokenResponse) =>  verifyGoogleUser(tokenResponse.access_token),
  });
  /**
   * Google Login token verify and Login
   * @param credentialResponse
   */
  const verifyGoogleUser = (credentialResponse: String) => {
    axios
      .post("/api/google/auth/login", { token: credentialResponse })
      .then((result: any) => {
        if (result.data.DATA.token) {
          // redirect to APP Dashboard
          signIn(result.data.DATA);
        }
      })
      .catch((e) => {
        // Default Error Dialog Title and Text
        let title = state.translate("error", "Error");
        let text = state.translate("setPassword.somthingWentwrong", "Something went wrong. Please try again.");

        const textMap = new Map<string, string>();
        textMap.set(
          noItx("User Not found."),
          state.translate(
            "loginPage.checkUserNameAndEmail",
            "Please check your username or email and try again. If you don't have an account, you can sign up to create one.",
          ),
        );
        textMap.set(
          itx("Login.emailNotVerified", "Email is not verified."),
          state.translate("loginPage.emailNotVerified", "Email is not verified."),
        );
        textMap.set(
          noItx("Something Went Wrong!"),
          state.translate("setPassword.somthingWentwrong", "Something Went Wrong!"),
        );
        textMap.set(
          noItx("Invalid user detected. Please try again"),
          state.translate("loginPage.emailNotVerified", "Invalid user detected. Please try again"),
        );

        textMap.forEach((value, key) => {
          if (key == e.DATA || key == e.message) {
            text = value;
          }
          if (e.DATA == "User Not found." || e.message == "User Not found.") {
            title = state.translate("loginPage.userNotFound", "User Not Found");
          }
        });

        state.dialogManager.openDialog(
          <BaseDialog
            className="dialog-standard"
            title={title}
            onOk={() => {
              return true;
            }}
            okCaption={state.translate("ok", "Ok")}
            noAbortButton={true}
          >
            <div style={{ padding: "20px" }}>{text}</div>
          </BaseDialog>,
        );
      });
  };

  const signIn = (credentials: any) => {
    // if (isDevelopmentEnvironment()) {
    //   credentials.abo = "development"; // no itx
    // }

    // check here if abo is availiable
    setUser(JSON.stringify(credentials));
    setSession(credentials.token);
    state.isLoggedIn = true;
    (window as any).isEstadaLoggedIn = true;
    navigate(redirectTarget, { replace: true });
  };
  const windowsWidth = window.innerWidth;

  return (
    <div id="App" className="App">
      <div className="Login main-form">
        <div className="lView">
          <div className="head">
            <div className="logo" style={{ cursor: "default" }}>
              <img src={`${state.hostBaseUrl}images/logo.png`} />
              <span className="logoText logoTextHome">{noItx("ESTADA")}</span>
            </div>
            <span className="title form-title">{state.translate("loginPage.loginTitle", "Sign in your account")} </span>

            <Formik
              initialValues={{ email: emailDefault, password: "" }}
              validationSchema={loginSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting }) => {
                return (
                  <Form>
                    <div className="inp" style={{ maxWidth: `${windowsWidth}px` }}>
                      <label className="field-container" style={{ position: "relative" }}>
                        <span className="form-label">
                          {/* {state.translate("loginPage.email", "Email")} <RequiredLabel /> */}
                        </span>
                        <span
                          className="form-span input-container"
                          style={{
                            //minWidth: "400px",
                            maxWidth: `${windowsWidth - 10}px`,
                          }}
                        >
                          <i className="la la-envelope la-lg input-icon" />
                          <Field
                            id="mailInput"
                            className="form-input input-field"
                            type="email"
                            name="email"
                            maxLength="255"
                            placeholder={""}
                            defaultValue={emailDefault}
                          />
                          <label className="input-label">
                            {state.translate("loginPage.email", "Email")}
                            <RequiredLabel />
                          </label>
                        </span>
                        <ErrorMessage className="form-error" name="email" component="div" />
                      </label>
                      <label className="field-container">
                        <span className="form-label">
                          {/* {state.translate("loginPage.password", "Password")} <RequiredLabel /> */}
                        </span>
                        <span
                          className="form-span input-container"
                          style={{
                            paddingLeft: "5px",

                            maxWidth: `${windowsWidth - 10}px`,
                          }}
                        >
                          <i className="la la-lock la-lg input-icon" />
                          <Field
                            id="passwordInput"
                            className="form-input input-field"
                            type={seePasword ? "text" : "password"} // no itx
                            name="password" // no itx
                            maxLength="64"
                            placeholder={""}
                          />
                          <label className="input-label">
                            {state.translate("loginPage.password", "Password")}
                            <RequiredLabel />
                          </label>
                          <i
                            className="las la-eye"
                            style={{
                              color: "black",
                              position: "absolute",
                              right: "10px",
                            }}
                            onMouseDown={() => setSeePassword(true)}
                            onMouseUp={() => setSeePassword(false)}
                          />
                        </span>
                        <ErrorMessage className="form-error" name={noItx("password")} component="div" />
                      </label>
                    </div>
                    <div className="endItems">
                      <button
                        id="submitLogin"
                        disabled={isSubmitting}
                        className="confirm-button button-full"
                        type="submit" // no itx
                        style={{
                          paddingLeft: "5px",

                          maxWidth: `${windowsWidth - 10}px`,
                        }}
                      >
                        <span>{state.translate("loginPage.signIn", "Sign In")}</span>
                      </button>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </div>
          <div className="seperator">
            <div />
            <span>{state.translate("or", "or")}</span>
            <div />
          </div>
          <button onClick={() => googleSignIn()} className="confirm-button">
            <span>{state.translate("loginPage.loginGoogle", "Log in with Google")}</span>
          </button>
          <div className="endItems">
            <span className="info">
              {state.translate("loginPage.noAccount", "You don’t have an account?")}{" "}
              <Link
                to={"/register"} // no itx
                state={{ from: redirectTarget }}
                className="form-link" // no itx
                onClick={() => {
                  console.log("register clicked");
                }}
              >
                {state.translate("loginPage.register", "Register")}
              </Link>
              !
            </span>
            <span className="info">
              <Link
                to={"/forget-password"} // no itx
                className="form-link" // no itx
              >
                {state.translate("loginPage.forgetPassword", "Forget Password")}
              </Link>
            </span>
          </div>
        </div>

        <div className="rView">
          <img
            src="/images/auth/rView.png" // no itx
            alt="" // no itx
          />
        </div>
        <LanguagePicker className="language-picker" />
        {/* <DialogHost /> */}
      </div>

      <GlobalWaitIndicator />
    </div>
  );
}

export function updateUserDetails(data: any) {
  let payload = {
    ...data,
    email: state.loggedInUser.email,
  };
  axios
    .post("/api/updateUser", payload)
    .then((result: any) => {
      logger.log(result);
    })
    .catch((ex) => {
      logger.log(ex);
    });
}

export function encrypt(text: string) {
  return CryptoJS.AES.encrypt(text, "6166246B99C5BC18DA75E7439C58D").toString(); // no itx
}
export function decript(text: string) {
  return CryptoJS.AES.decript(text, "6166246B99C5BC18DA75E7439C58D").toString(); // no itx
}

export const RequiredLabel = () => {
  return (
    <span
      className="required"
      data-tooltip-id="tv-tooltip"
      data-tooltip-content={state.translate("loginPage.required", "required")}
      data-tooltip-place="right"
    >
      *
    </span>
  );
};

async function getUserProfilePic(guid: string): Promise<any | undefined> {
  try {
    const result = await axios.get(`/api/getUserProfilePic/${guid}`);

    return result;
  } catch (e) {
    logger.error("Error fetching profilepic image:", e);
    return undefined;
  }
}
